<script setup lang="ts">
import { ref, computed } from "vue"
import { useRoute } from 'vue-router'
import ModalShare from '~/components/ui/modal-share/ModalShare.vue'
import PopupCommon from '~/components/ui/popup/PopupCommon.vue'
import { TABLET } from '~/constant/common'
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import { debounceHeapTracking } from '~/mixins/heap'
import { useTripPlanStore } from '~/store/pinia/tripPlan'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

const route = useRoute()
const tripPlanStore = useTripPlanStore()
const generalStore = useGeneralInfoStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)
const pageType = computed(() => {
  if (route.name === 'trip-plan-bookable') return 'bookable'
  if (route.name === 'trip-preview') return 'preview'
  return 'gallery'
})
const windowWidth = computed(() => generalStore.generalData.windowWidth)

const modalShareActive = ref(false)
const customTripRef = ref<any>(null)
const customTripRefMobile = ref<any>(null)

function closeShareModal() {
  modalShareActive.value = false
}
function openPopupEditPrice() {
  if (windowWidth.value > TABLET) customTripRef.value!.openPopupEditPrice()
  else customTripRefMobile.value!.openPopupEditPrice()
}
function toggleModalShare(source: string) {
  modalShareActive.value = !modalShareActive.value
  debounceHeapTracking('View Share Trip Plan Popup', {
    source_widget: source,
  })
  debounceAmplitudeScriptTracking('View Share Trip Plan Popup', {
    source_widget: source,
  })
}
defineExpose({
  toggleModalShare,
  closeShareModal,
})
</script>

<template>
  <PopupCommon modalTitle="Share" :modalActive="modalShareActive" @update:close="closeShareModal" maxWidth="400">
    <template #content>
      <ModalShare :id="dataTrip.shared_id" :pageType="pageType" v-model:modalActive="modalShareActive" @editTrip="openPopupEditPrice" />
    </template>
  </PopupCommon>
</template>

<style lang="scss" scoped></style>
